import { Link } from 'react-router-dom'
import { Waterline } from '../components/Waterline'
import ftBefore from '../assets/ft-before.jpg'
import ftAfter from '../assets/ft-after.jpg'
import ftAdmin from '../assets/ft-admin.jpg'

export function Work() {
  return (
    <>
      <section className="section prose">
        <div className="wrap">
          <p className="eyebrow">Case study</p>
          <h1>FloorTracks</h1>
          <p className="lede">
            Original music for gymnastics floor routines, sold as single
            tracks with an editing service attached.{' '}
            <a href="https://floortracks.net" target="_blank" rel="noreferrer">
              floortracks.net
            </a>
          </p>
          <ul className="fact-list">
            <li>Live since August 2026</li>
            <li>Catalog · checkout · delivery · admin</li>
            <li>Dedicated AWS account</li>
          </ul>

          <h2>The starting point</h2>
          <p>
            FloorTracks had been selling music online for years from a store
            built on Joomla, with a music-catalog extension and a shopping-cart
            extension bolted together. The system had aged to the point where
            changing anything safely was hard, and the business needed to move
            without losing the catalog it had built up.
          </p>

          <figure className="compare">
            <div>
              <p className="figure-label">Before</p>
              <img
                src={ftBefore}
                alt="The old FloorTracks home page: a dated Joomla site with dropdown search menus and an embedded video"
                loading="lazy"
              />
            </div>
            <div>
              <p className="figure-label">After</p>
              <img
                src={ftAfter}
                alt="The rebuilt floortracks.net home page: full-text search, browsable volumes, and on-site checkout"
                loading="lazy"
              />
            </div>
          </figure>

          <h2>What Loonworks built</h2>
          <ul>
            <li>
              <strong>The catalog survived the move.</strong> The old site
              was captured page by page before the switch, and every track
              carried into the new store: titles, previews, cover art.
            </li>
            <li>
              <strong>Checkout on the site itself.</strong> Customers buy
              tracks with Stripe and get their music immediately.
            </li>
            <li>
              <strong>Delivery with no passwords.</strong> Purchases arrive as
              secure download links, on the confirmation page and by email. No
              accounts to create, nothing to forget.
            </li>
            <li>
              <strong>Admin tools for the owner.</strong> The catalog, uploads,
              and orders are managed in the site's own admin. No more Joomla
              back end.
            </li>
            <li>
              <strong>A dedicated AWS account.</strong> The whole store runs
              in an AWS account of its own, managed by Loonworks: the site
              served from CloudFront, music files in S3, the domain on Route
              53. If FloorTracks ever wanted out, the account could go with
              them.
            </li>
          </ul>

          <figure className="shot">
            <img
              src={ftAdmin}
              alt="The FloorTracks admin: a searchable table of every track with pricing, preview status, and publish state"
              loading="lazy"
            />
            <figcaption>
              The owner's side: the whole catalog managed from the site's own
              admin.
            </figcaption>
          </figure>

          <h2>Where it stands</h2>
          <p>
            The new store went live on August 14, 2026 and has been taking
            real orders since: customers pay on the site and their music
            arrives on its own, no hands involved. The Joomla site is
            retired.
          </p>
        </div>
      </section>

      <Waterline />

      <section className="section">
        <div className="wrap">
          <p>More work will show up here as it ships.</p>
          <Link to="/contact" className="button button--primary">
            Yours could be next
          </Link>
        </div>
      </section>
    </>
  )
}
